import {Shop} from './Shop';
import {SignIn} from './SignIn';
import {SignUp} from './SignUp';
import {Filter} from './Filter';
import {Reviews} from './Reviews';
import {Product} from './Product';
import {Checkout} from './Checkout';
import {InfoSaved} from './InfoSaved';
import {EditProfile} from './EditProfile';
import {OrderFailed} from './OrderFailed';
import {NewPassword} from './NewPassword';
import {Description} from './Description';
import {OrderHistory} from './OrderHistory';
import {MyPromocodes} from './MyPromocodes';
import {LeaveAReviews} from './LeaveAReviews';
import {ForgotPassword} from './ForgotPassword';
import {OrderSuccessful} from './OrderSuccessful';
import {VerifyYourEmail} from './VerifyYourEmail';
import {MyPromocodesEmpty} from './MyPromocodesEmpty';
import {OrderHistoryEmpty} from './OrderHistoryEmpty';
import {ShippingAPaymentInfo} from './ShippingAPaymentInfo';
import {EmailHasBeenVerified} from './EmailHasBeenVerified';
import {SignUpAccountCreated} from './SignUpAccountCreated';
import {VerifyYourPhoneNumber} from './VerifyYourPhoneNumber';
import {ShippingAndPaymentInfo} from './ShippingAndPaymentInfo';
import {ForgotPasswordSentEmail} from './ForgotPasswordSentEmail';
import {PhoneNumberHasBeenVerified} from './PhoneNumberHasBeenVerified';

// Verifications
import {VerifyPhone} from './verification/VerifyPhone';
import {VerifyEmail} from './verification/VerifyEmail';
import {SendEmailOtp} from './verification/SendEmailOtp';
import {SendPhoneOtp} from './verification/SendPhoneOtp';
import {EmailVerified} from './verification/EmailVerified';
import {PhoneVerified} from './verification/PhoneVerified';

export const screens = {
  Shop,
  SignIn,
  Filter,
  SignUp,
  Reviews,
  Product,
  Checkout,
  InfoSaved,
  VerifyPhone,
  EditProfile,
  Description,
  OrderFailed,
  NewPassword,
  VerifyEmail,
  SendEmailOtp,
  SendPhoneOtp,
  OrderHistory,
  MyPromocodes,
  LeaveAReviews,
  EmailVerified,
  PhoneVerified,
  ForgotPassword,
  VerifyYourEmail,
  OrderSuccessful,
  OrderHistoryEmpty,
  MyPromocodesEmpty,
  ShippingAPaymentInfo,
  SignUpAccountCreated,
  EmailHasBeenVerified,
  VerifyYourPhoneNumber,
  ShippingAndPaymentInfo,
  ForgotPasswordSentEmail,
  PhoneNumberHasBeenVerified,
};
